import axios from 'axios';

export default {
  getPublicConfigByKey(configKey) {
    return axios.get(`/v1/public-system-config/${configKey}`)
      .then(function (response) {
        return Promise.resolve(response);
      })
      .catch(function (error) {
        return Promise.reject(error);
      });
  },
  getConfigByKey(configKey) {
    return axios.get(`/v1/system-config/${configKey}`)
      .then(function (response) {
        return Promise.resolve(response);
      })
      .catch(function (error) {
        return Promise.reject(error);
      });
  },

  getAllConfigs(params = {}) {
    return axios.get('/v1/system-config', {
      params
    })
      .then(function (response) {
        return Promise.resolve(response);
      })
      .catch(function (error) {
        return Promise.reject(error);
      });
  },

  createConfig(payload) {
    return axios.post('/v1/system-config', payload)
      .then(function (response) {
        return Promise.resolve(response);
      })
      .catch(function (error) {
        return Promise.reject(error);
      });
  },

  updateConfigByKey(configKey, payload) {
    return axios.put(`/v1/system-config/${configKey}`, payload)
      .then(function (response) {
        return Promise.resolve(response);
      })
      .catch(function (error) {
        return Promise.reject(error);
      });
  },

  deleteConfigByKey(configKey) {
    return axios.delete(`/v1/system-config/${configKey}`)
      .then(function (response) {
        return Promise.resolve(response);
      })
      .catch(function (error) {
        return Promise.reject(error);
      });
  }
};